<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMemberBackTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">苗场黑名单列表</span>
                    </div>
                    <div class="right-bar">
						<Button size="small"
						    class="btns"
						    shape="circle"
						    type="success"
						    icon="ios-add-circle-outline"
						    @click="onMemberBlackCreate">新增</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="mainTable.tableData"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMemberBackTableRecords" />
                </Col>
            </Row>
        </Card>
		
		
		<Modal v-model="memberBlackModal.show"
		    title="新增黑名单"
		    class-name="vertical-center-modal"
		    width="1000" >
		   <Spin v-if="innerSpin"
		        size="large"
		        fix></Spin>
		    <Form label-position="left" :label-width="60"
				ref="memberBlackModal"
				:model="memberBlackModal">
		        <Row :gutter="16">
		            <Col span="7">
		            <FormItem label="会员号">
						<Input v-model="memberBlackModal.memberCode">
						</Input>
		            </FormItem>
		            </Col>
		            <Col span="7">
		            <FormItem label="会员名称">
		                <Input v-model="memberBlackModal.memberName"></Input>
		            </FormItem>
		            </Col>
					<Col span="7">
					<FormItem label="手机号码">
					    <Input v-model="memberBlackModal.memberPhone"></Input>
					</FormItem>
					</Col>
					<Col span="2">
						<FormItem :label-width="0">
							<Button type="primary"                   
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="onSearchMember()">搜索</Button>
					</FormItem>
		
					</Col>
		        
		        </Row>
			
		    </Form>
			<Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTableBlack.columns"
                    :data="mainTableBlack.tableData"
					:table-search="mainTableBlack.tableSearch"
                    :loading="mainTableBlack.tableLoading"  
					:table-load-event="mainTableBlack.tableLoadEvent"
                    :showPage="false" />
                </Col>
            </Row>
		    <!-- <div slot="footer">
				<Button type="primary" @click="onSaveMemberBlack">确认</Button>
				<Button type="error" @click="onMemberBlackCancel">取消</Button>
		    </div> -->
            <SeedFarmMemberBlackModal ref="seedFarmMemberBlackModal" @refresh="refresh"/>
		</Modal>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import { getSeedFarmBlackUserList, getUserList, saveSeedFarmBlackUser, delSeedFarmBlackUser } from '@/api/modules/seedFarm-management/seedFarm-member-back';
import { getBinFenSeedFarmUserList } from '@/api/modules/account-management/binFenSeedFarm-user-management';
import SeedFarmMemberBlackModal from './seedFarm-member-black-modal.vue';
import { refresh } from 'less';
export default {
    name: 'MemberBackList',
    components: {
        SearchCard,
        StandPaginationTable,
        SeedFarmMemberBlackModal
    },
    data() {
        return {
            mainTable: {
                columns: [
                    //{ title: '行号', type: 'index', width: 80, align: 'center' },
                    { title: '编号', key: 'seedFarmCode', align: 'center' },
                    { title: '名称', key: 'seedFarmName', align: 'center' },
                    { title: '会员号', key: 'userName', align: 'center' },
                    { title: '姓名', key: 'userPersonName', align: 'center' },
                    { title: '手机号码', key: 'userPhone', align: 'center' },
                    {
                        title: '状态',
                        key: 'recordStatus',
                        align: 'center',
                        render: (h, params) => {
                            let text = params.row.recordStatus ===1 ? '黑名单' : '正常';
                            let color = params.row.recordStatus ===1 ? '' : 'red';
                            return h('div', [
                                h('span', {
                                    style: {
                                        color: color
                                    }
                                }, text)
                            ]);
                        }
                    },
                    { title: '修改人', key: 'modifierName', align: 'center' },
                    {
                        title: '设置时间', key: 'modifyTime', align: 'center', render: (h, params) => dateTimeRender(h, params.row.modifyTime)
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        //fixed: 'right',
                        width: 180,
                        render: (h, params) => {
                            const { recordStatus, blackUserUuid, userUuid } = params.row;
                            let btnText =recordStatus===1?"移除黑名单":"加入黑名单";
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                        color: recordStatus == 1 ? "#006400" : "#FF0000",
                                        display: this.$checkAccessArray(['S', 'B']) ? 'inline' : 'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.onToggleMemberBack(params.row);
                                        }
                                    }
                                }, btnText),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                        display: this.$checkAccessArray(['S', 'B']) ? 'inline' : 'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.$refs.seedFarmMemberBlackModal.showModal(blackUserUuid, userUuid);
                                        }
                                    }
                                }, '编辑')
                            ]);
                        }
                    }
                ],
                tableData: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '苗场编号', type: 'Input', value: '', name: 'seedFarmCode', sql: 'like' },
                    { label: '苗场名称', type: 'Input', value: '', name: 'seedFarmName', sql: 'like' },
                    { label: '会员帐号', type: 'Input', value: '', name: 'blackUser.userName', sql: 'like' },
                    { label: '姓名', type: 'Input', value: '', name: 'userPersonName', sql: 'like' },
                    { label: '手机号码', type: 'Input', value: '', name: 'userPhone', sql: 'like' }
                ],
                tableLoading: false,
                tableSearch: search.getSearchParams()
            },
            mainTableBlack:{
                columns: [
                    //{ title: '行号', type: 'index', width: 80, align: 'center' },
			
                    { title: '会员号', key: 'userName', align: 'center' },
                    { title: '姓名', key: 'userPersonName', align: 'center' },
                    { title: '手机号码', key: 'userPhone', align: 'center' },
                    {
                        title: '状态',
                        key: 'recordStatus',
                        align: 'center',
                        render: (h, params) => {
                            let text = params.row.recordStatus ===1 ? '黑名单' : '正常';
                            let color = params.row.recordStatus ===1 ? '' : 'red';
                            return h('div', [
                                h('span', {
                                    style: {
                                        color: color
                                    }
                                }, text)
                            ]);
                        }
                    },
                    { 
                        title: '关联苗场', key: "seedFarmUuid", width: 120, align: 'center',
                        render: (h, params) => {
                            return h('Select', {
                                props: {
                                    filterable: true,
                                    transfer: true,
                                    value: params.row.seedFarmUuid,
                                    disabled: !this.$checkAccessArray([ 'S' ])
                                },
                                style: {
                                    width: '100%'
                                },
                                on: {
                                    'on-change': newVal => {
                                        this.mainTableBlack.tableData[params.index].seedFarmUuid = newVal;
                                    }
                                }
                            }, 
                            [
                                this.seedFarmList.map(item => {
                                    return h('Option', {
                                        props: {
                                            value: item.userBinFenSeedFarmRelateFarmUuid,
                                            label: item.seedFarmName+"("+item.userName+"-"+item.userBinFenSeedFarmName+")"
                                        }
                                    });
                                })
                            ]);
                        }
                    },
                    // { title: '苗场编号', key: 'seedFarmCode', align: 'center'},
                    // { title: '苗场名称', key: 'seedFarmName', align: 'center' },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        //fixed: 'right',
                        width: 180,
                        render: (h, params) => {
                            if (params.row.recordStatus != 1) {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {
                                            color: "#006400"
                                        },
                                        on: {
                                            click: () => {
                                                this.onSaveMemberBlack(params.row);
                                            }
                                        }
                                    }, "加入黑名单")
                                ]);
                            }

                        }
                    }
                ],
                tableData: [],
                tableSearch: search.getSearchParams(),
                tableLoading: false,
                tableLoadEvent:()=>{
                    this.mainTableBlack.tableData=[];
                }
            },
            memberBlackModal: {
                show: false,
                memberUuid:'',
                memberCode:'',
                memberName:'',
                memberPhone:'',
                recordStatus:1
                //reason:''
            },
            innerSpin: false,
            seedFarmList: []
        };
    },
    mounted() {
        this.getMemberBackTableRecords();
	    this.getSeedFarmList();
    },
    methods: {
        refresh(){
            this.getMemberBackTableRecords();
        },
        getMemberBackTableRecords(reset = false) {
            this.mainTable.tableLoading = true;
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getSeedFarmBlackUserList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
                this.mainTable.tableLoading = false;
            }).catch(() => {
                this.mainTable.tableLoading = false;
            });
        },
        //搜索会员号
        onSearchMember(){
            this.mainTableBlack.tableData=[];
            if (!this.memberBlackModal.memberCode &&!this.memberBlackModal.memberName && !this.memberBlackModal.memberPhone) {
                this.$Modal.warning({
                    title: '搜索条件不能都为空'
                });
                return;
            }
            let tempSearch = search.getSearchParams();
            tempSearch.limit.enable = false;
            tempSearch.filters.enable = true;
            if (this.memberBlackModal.memberCode) {
                tempSearch.filters.conditions.push({
                    name: 'userName',
                    type: 'eq',
                    value: this.memberBlackModal.memberCode
                });
            }
            if (this.memberBlackModal.memberName) {
                tempSearch.filters.conditions.push({
                    name: 'users.userPersonName',
                    type: 'like',
                    value: this.memberBlackModal.memberName
                });
            }
            if (this.memberBlackModal.memberPhone) {
                tempSearch.filters.conditions.push({
                    name: 'users.userPhone',
                    type: 'eq',
                    value: this.memberBlackModal.memberPhone
                });
            }
            getUserList(tempSearch).then(res=>{
                if(res.code===0){
                    if(res.data.records.length>0){
                        let memberInfo=res.data.records[0];
                        this.mainTableBlack.tableData=res.data.records;
                        // this.memberBlackModal.memberCode=memberInfo.userName;
                        // this.memberBlackModal.memberName=memberInfo.userExternalCustomerName;
                        // this.memberBlackModal.memberPhone=memberInfo.userExternalCustomerPhone
                        // this.memberBlackModal.memberUuid=memberInfo.userExternalCustomerLoginUuid
                    }
                    else{
                        this.$Modal.error({ title: '查询不到该会员，请确认搜索信息是否有误', content: '' });
                        return;
                    }
                }
            });
        },
        //修改列表黑名单状态
        onToggleMemberBack(row) {
            this.innerSpin = true;
            let recordStatusInt = row.recordStatus=== -1 ? 1:-1;
            if(recordStatusInt == 1){
                saveSeedFarmBlackUser({ blackUserUuid: row.blackUserUuid, userUuid:row.userUuid, recordStatus:recordStatusInt }).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '更新成功',
                            content: '',
                            onOk: () => {
                                this.mainTable.tableSearch = search.getSearchParams();
                                this.getMemberBackTableRecords();
                            }
                        });
                    }
                });
            }
            else{
                delSeedFarmBlackUser({ blackUserUuid: row.blackUserUuid, userUuid:row.userUuid, recordStatus:recordStatusInt }).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '更新成功',
                            content: '',
                            onOk: () => {
                                this.mainTable.tableSearch = search.getSearchParams();
                                this.getMemberBackTableRecords();
                            }
                        });
                    }
                });
            }
        },
        //打开新增页面
        onAdd(){
            this.memberBlackModal.memberUuid='',
            this.memberBlackModal.memberCode='',
            this.memberBlackModal.memberName='',
            this.memberBlackModal.memberPhone='',
            this.memberBlackModal.recordStatus=1;
            //this.memberBlackModal.reason=''
        },
        //新增黑名单
        onMemberBlackCreate(){
            this.onAdd();
            this.memberBlackModal.show = true;
            this.mainTableBlack.tableData=[];
        },
        //保存黑名单
        onSaveMemberBlack(row){
            if(!row.userExternalCustomerLoginUuid){
                this.$Modal.error({ title: '请先查询确认该会员的信息，确保无误！！！', content: '' });
                return;
            }
            let data={
                blackUserUuid: row.blackUserUuid?row.blackUserUuid:'',
                userUuid: row.userExternalCustomerLoginUuid,
                seedFarmUuid: row.seedFarmUuid,
                recordStatus: row.recordStatus===1 ? -1:1
            };
            this.innerSpin = true;
            saveSeedFarmBlackUser(data).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.memberBlackModal.show = false;
                            this.getMemberBackTableRecords();
                        }
                    });
                }
            });
        },
        //取消保存黑名单
        onMemberBlackCancel(){
            this.onAdd();
            this.memberBlackModal.show = false;
        },
        getSeedFarmList(){
            let tableSearch = search.getSearchParams({ closeAllConditions: true });
            search.globalAddFilterConditionKey(tableSearch, "userBinFenSeedFarmApproval", "eq", 1, true);
            getBinFenSeedFarmUserList(tableSearch).then(res=>{
                if(res.code===0){
                    this.seedFarmList=res.data.records;
                    if(this.$checkAccessArray([ 'S' ])){
                        let all = {
                            isMainAccount: 1,
                            seedFarmName: "全部苗场",
                            userBinFenSeedFarmApproval: 1,
                            userBinFenSeedFarmContactNumber: "",
                            userBinFenSeedFarmLoginUuid: "all",
                            userBinFenSeedFarmName: "全部",
                            userBinFenSeedFarmRelateFarmUuid: "all",
                            userBinFenSeedFarmStatus: "",
                            userBinFenSeedFarmWechat: "",        
                            userName: "all"
                        };
                        this.seedFarmList.unshift(all);
                    }
                    
                }
            });
        }
    }
};
</script>

<style scoped>
</style>
